module.exports = __webpack_public_path__ + "u6.no2.794f90ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u6.no2.jpg
// module id = 5uT/
// module chunks = 0